import React from 'react';
import EntitiesErrorMessages from '@/components/errors/EntitiesErrorMessages';
import DatasetAdminPanelHeader from './DatasetAdminPanelHeader';
import DatasetAdminPanelContainer from '../components/DatasetAdminPanelContainer';
import DatasetAdminAccordion from '../components/DatasetAdminAccordion';
import selectors from '../hooks/selectors';
import events from '../hooks/events';
import fetch from '../../metrics/hooks/fetch';

const DatasetAdminPanelNarrow = ({
  category,
  code,
  onChange,
  url,
}) => {
  const state = selectors.useDatasetSettings({ category, code });
  const updateProperties = events.useUpdateDatasetSettingsProperties(category, { code });
  fetch.useFetchDatasetMetrics({ category, code }, state.metricsReadStatus);

  return (
    <DatasetAdminPanelContainer
      canRead={state.canRead}
      category={category}
      code={code}
      exists={state.exists}
      readErrors={state.readErrors}
      readStatus={state.readStatus}
    >
      <div className="aridhia-dataset-admin-panel-narrow">
        <DatasetAdminPanelHeader code={code} category={category} onChange={onChange} url={url} />
        <EntitiesErrorMessages
          category={category}
          code={code}
          entity="dataset-settings"
          errors={state.saveErrors}
          onDismiss={(errors) => updateProperties({ properties: { saveErrors: errors } })}
        />
        <DatasetAdminAccordion
          category={category}
          code={code}
          name={state.name}
          panels={state.panels}
          datasourceSupportsCohort={state.datasourceSupportsCohort}
        />
      </div>
    </DatasetAdminPanelContainer>
  );
};

export default DatasetAdminPanelNarrow;
